<style scoped  lang="less">
  @import '../../../style/reset.less'; // 引入公共LESS文件
  .crumbs{
    font-size: 0;
    white-space: nowrap;
    padding: 15px 0 15px 0;
    color:@color_8C8C8C; 

    .countryIcon{
      width: 20px;
      height: 20px;
      object-fit: cover;
      border-radius: 50%;
    }
    *{
      height: 20px;
      display: inline-block; 
      vertical-align: top; 
      font-size: 14px; 
      height: 20px; 
      line-height: 20px; 
      color:@color_8C8C8C;
    }
    .leftIcon{
      font-family: @font_family_PublicSans_Bold;
      display: inline-block;
      color: @color_595959;
      margin: 0 5px;
    }
    a{
      color:@color_8C8C8C; display: inline-block; vertical-align: middle;
      img{
        display: inline-block; vertical-align: middle;width: 18px; 
          height: 12px; border: 1px solid @color_D9D9D9;margin: 0;margin-right: 6px;
      }
      &.a_noUrl{
        user-select: none !important;
      }
    }
    .span_shortName{display: none;}
  }

@media screen and (max-width: 767px) {
  .crumbs{
    width: 100vw;
    overflow: auto;
    padding: .08rem .12rem;
    background: @color_F5F5F5;

    .countryIcon{
      width: .16rem;
      height: .16rem;
    }
    *{
      height: .16rem;
      display: inline-block; 
      vertical-align: top; 
      // font-size: .12rem; 
      // zoom: .83;
      font-size: .1rem; 
      line-height: .16rem;
      color: @color_595959;
    }
    .leftIcon{
      font-weight: normal;
      margin: 0 .04rem;
    }
    a{
      
      img{
        width: 18px; 
        height: 12px; 
        border: 1px solid @color_D9D9D9;
        margin-right: 6px;
      }
      
    }
    
  }

}
.a_last{color: @color_434343 !important;}

</style>
<template>
  <div>
    <div class="crumbs" v-if="league!=null">
      <template>
        <!-- <router-link class=" flex flex-align-center a_last" :to="{path: '/leagues/' + league.id+'/0'}" v-if="league.hasDt"> -->
        <div class=" flex flex-align-center a_last" >
          <img class="countryIcon" :src="common.noCountryBack(league, 'img')" @error="common.imgError($event, 'country')" alt="">
          <span>{{league.country.name}}</span>
          <span class="leftIcon">></span>
          <span class="span_fullName">{{league.fullName}}</span>
          <span class="leftIcon">></span>
          <span>{{match['homeTeam']['fullName']}} - {{match['awayTeam']['fullName']}} Prediction</span>
        </div>
        <!-- </router-link> -->
      </template>
        <!-- <a class="a_noUrl">{{ langConfig.footer[langConfig.curLang]['FOOTBALL'] }}</a> 
        <s></s>
        <router-link :to="{path: '/live'}">
          {{ langConfig.footer[langConfig.curLang]['SCORE'] }}
        </router-link>
        <s></s>
        <template>
          <router-link class=" flex flex-align-center a_last" :to="{path: '/leagues/' + league.id+'/0'}" v-if="league.hasDt">
            <img  :src="common.noCountryBack(league, 'img')" @error="common.imgError($event, 'country')" alt="">
            <span class="span_fullName">{{common.noCountryBack(league, 'name')}}{{league.fullName}}</span>
            <span class="span_shortName">{{common.noCountryBack(league, 'name')}}{{league.shortName}}</span>
            
          </router-link>
          <a href="javascript:void(0);" class="a_noUrl a_last" v-else style="cursor: default;">
            <img  :src="common.noCountryBack(league, 'img')" @error="common.imgError($event, 'country')" alt="">
            <span class="span_fullName">{{common.noCountryBack(league, 'name')}}{{league.fullName}}</span>
            <span class="span_shortName">{{common.noCountryBack(league, 'name')}}{{league.shortName}}</span>
          </a>
        </template> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "detailsCrumbs",
  data() {
    return {
      
    };
  },
  
  created() {
    
  
  },
  methods: { 
   
  },
  watch: {

  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    league: {
      type: Object,
      default:null
    }, 
    match: {
      type: Object,
      default:null
    }, 
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsCrumbs.vue